import React from 'react';
import { List, Popconfirm, message, Skeleton, Divider, Button, Icon, Empty } from "antd";
import axios from "axios";
import { withTranslation } from 'react-i18next';
import EventForm from '../Events/EventForm';

class LeadFormEventSidebar extends React.Component {
    state = ({
        modalEvent: {},
        modalRequestType: '',
        // modalLoading: true,
        modalBtnText: "",
        modalVisible: false,
        modalTitleText: "",
    });

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleDelete(eventID) {
        axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/delete/`)
            .then(res => {
                if (res.status === 204 || res.status === 200) {
                    const data = this.props.lead.events;
                    const data_fixed = data.filter(item => item.id !== eventID);
                    let new_data = this.props.lead;
                    new_data.events = data_fixed;
                    this.props.handleState('lead', new_data);
                    message.success(this.props.t('events.event_list.event_deleted', "Event deleted"));
                } else {
                    message.warning(this.props.t('events.event_list.event_deletion_failed', "Deletion failed"));
                }
            })
    };

    confirmDelete(event, eventID) {
        event.preventDefault();
        this.handleDelete(eventID);
    }

    showModal = () => {
        this.formRef.resetFields();
        this.setState({
            modalVisible: true,
            modalTitleText: this.props.t('events.event_list.modal_title_create', "Create a new event"),
            modalRequestType: "post",
            modalBtnText: this.props.t('general.create', "Create"),
            modalEvent: {},
        });
    };

    hideModal = () => {
        this.setState({
            modalVisible: false,
        });
    };

    handleCreate = () => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }

            this.hideModal();
            axios.post(process.env.REACT_APP_AXIOS_URL + "/api/events/create/", postObj)
                .then(res => {
                    if (res.status === 201) {
                        this.props.fetch();
                        message.success(this.props.t('events.event_list.event_created', "Event created successfully"));
                    }
                })

            this.formRef.resetFields();
        });
    };

    handlePreview = event => {
        const eventID = event.currentTarget.getAttribute('data-event_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalEvent: res.data,
                        // modalLoading: false,
                        modalBtnText: undefined,
                        modalVisible: true,
                        modalRequestType: "get",
                        modalTitleText: this.props.t('events.event_list.modal_title_preview', "Previewing a event")
                    });
                } else {
                    this.props.history.push('/events');
                }
            })
    };

    handleEditPreview = event => {
        const eventID = event.currentTarget.getAttribute('data-event_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalEvent: res.data,
                        // modalLoading: false,
                        modalBtnText: this.props.t('general.update', "Update"),
                        modalVisible: true,
                        modalRequestType: "put",
                        modalTitleText: this.props.t('events.event_list.modal_title_update', "Update event")
                    });
                } else {
                    this.props.history.push('/events');
                }
            })
    };

    handleEdit = event => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }
            const eventID = this.state.modalEvent.id;
            this.hideModal();
            axios.put(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/update/`, postObj)
                .then(res => {
                    if (res.status === 200) {
                        this.props.fetch();
                        message.success(this.props.t('events.event_list.event_updated', "Event have been updated"));
                    }
                })

            // this.formRef.resetFields();
        });
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    handleState = (key, value) => {
        let obj = {};
        obj[key] = value;
        this.setState(obj);
    }


    render() {
        const { events, t } = this.props;

        if (this.props.loading) {
            return (
                <div>
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                </div>
            );
        } else {
            return (
                <div>
                    <Button style={{ borderRadius: '0px' }} type="dashed" onClick={this.showModal}>
                        <Icon type="plus" />
                        {t('general.create', "Create")}
                    </Button>
                    {
                        events && events.length > 0 ?
                            <List
                                itemLayout="horizontal"
                                dataSource={events}
                                renderItem={event => (
                                    <List.Item>
                                        <List.Item.Meta
                                            // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                                            title={event.name}
                                            description={
                                                <div>
                                                    <a onClick={this.handlePreview} data-event_id={event.id} key="event=list-view">View</a> <Divider type="vertical" />
                                                    <a onClick={this.handleEditPreview} data-event_id={event.id} key="event-list-edit">Edit</a> <Divider type="vertical" />
                                                    <Popconfirm
                                                        title={t('events.event_list.event_delete', "Are you sure want to delete this event?")}
                                                        onConfirm={(e) => {
                                                            this.confirmDelete(e, event.id);
                                                        }}
                                                        okText={t('general.yes', "Yes")}
                                                        cancelText={t('general.no', "No")}
                                                        className='data-id={event.id}'
                                                    >
                                                        <a key="event-list-delete" href="#">{t('general.delete', "Delete")}</a>
                                                    </Popconfirm><br>
                                                    </br>
                                                    {event.description}
                                                </div>
                                            }
                                        />
                                    </List.Item>
                                )}
                            /> :
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }
                    <EventForm
                        wrappedComponentRef={(form) => this.formRef = form}
                        visible={this.state.modalVisible}
                        onCancel={this.hideModal}
                        btnText={this.state.modalBtnText}
                        titleText={this.state.modalTitleText}
                        handleState={this.handleState}
                        requestType={this.state.modalRequestType}
                        data={this.state.modalEvent}
                        fetch={this.props.fetch}
                        tags={this.props.tags}
                        users={this.props.users}
                        contacts={this.props.contacts}
                        event_status_list={this.props.event_status}
                        event_type_list={this.props.event_type}
                        lead_list={this.props.leads}
                    />
                </div>
            );
        }

    }
}

export default withTranslation()(LeadFormEventSidebar);


// WEBPACK FOOTER //
// ./src/containers/Leads/LeadFormEventSidebar.js